export default __webpack_public_path__ + "static/media/bannerOne.7bebe386.jpg";